import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const learnUpon = defineConnector({
  identifier: "learnUpon",
  name: "LearnUpon",
  tagLine: "Learning management system",
  logo,
  protocol: "http",
  tags: ["productivity"],
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your LearnUpon API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In LearnUpon, generate API credentials and use them with HTTP basic authentication for API requests.",
        },
      ],
    },
    {
      title: "Enter your LearnUpon details",
      items: [
        {
          kind: "baseUrl",
          label: "LearnUpon base URL",
          required: true,
          placeholder: "https://your-company.learnupon.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "API password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://your-company.learnupon.com"}/api/v1/users`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.learnupon\\.com/.*"),
});
